export default __webpack_public_path__ + "static/media/t9.f22f1035.jpg";